<!--
  Root shell. Three siblings that span every route:
    - ng-http-loader: top-bar progress indicator wired to the global HTTP pipeline.
    - router-outlet:  the per-route page chrome (auth = guest layout, customer = system layout).
    - p-toast:        PrimeNG toast host used by MessageService for inline errors.
-->
<ng-http-loader [backdrop]="false" [debounceDelay]="100" [filteredHeaders]="['ignore_http_loader']" [entryComponent]="progressBar"> </ng-http-loader>
<router-outlet />
<p-toast position="top-center"></p-toast>
